import React from 'react'
import styled from '@emotion/styled';
import ReactPlayer from 'react-player';
import { Helmet } from 'react-helmet';

import { fontEn, grayBorder, breakP, text, mq, dot, fastDurationTime, baseDurationTime, black01 } from '../../_style';
import btnLineup from '../../assets/imgs/premiumcare/btn-lineup.svg';
import btnLineupBase from '../../assets/imgs/premiumcare/btn-lineup-base.svg';
import btnLineupHover from '../../assets/imgs/premiumcare/btn-lineup-hover.svg';
import btnLineupBaseHover from '../../assets/imgs/premiumcare/btn-lineup-base-hover.svg';
import btnLineupSp from '../../assets/imgs/premiumcare/sp/btn-lineup.svg';
import btnLineupBaseSp from '../../assets/imgs/premiumcare/sp/btn-lineup-base.svg';
import effectIcon01 from '../../assets/imgs/premiumcare/img-effects-01.svg'
import effectIcon02 from '../../assets/imgs/premiumcare/img-effects-02.svg'
import effectIcon03 from '../../assets/imgs/premiumcare/img-effects-03.svg'

import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';
import Image from '../../components/atoms/image';
import BtnBlank from '../../components/atoms/btnBlank';
import StimulationLevel from '../../components/atoms/stimulationLevel';
import ParallaxImage from '../../components/molecules/parallaxImage';
import LabelGroup from '../../components/molecules/labelGroup';
import ContentWidth from '../../components/organisms/contentWidth';
import Br from '../../components/atoms/br';
import InViewWrapper from '../../components/organisms/inViewWrapper';

const colorAccent = '#b09241';
const colorMain = '#121359';
const colorMainSub = '#121359';

const Container = styled.div`
${mq.pc} {
}
${mq.sp} {
}
`
const Hero = styled.div`
position: relative;
`
const HeroProduct = styled.div`
  position: absolute;
  bottom: ${83 / 707 * 100}%;
  left: ${73 / 1440 * 100}%;
  width: ${681 / 1440 * 100}%;
  z-index: 1;
  > div {
    opacity: 0;
    transform: translate3d(0, 14%, 0);
    transition: opacity ${parseFloat(baseDurationTime) * 2}s ease 1s, transform ${parseFloat(baseDurationTime) * 2}s ease 1s;
    &.is-shown {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`
const Nav = styled.nav`
background-color: ${colorAccent};
`
const NavList = styled.ul`
display: flex;
justify-content: center;
`
const NavItem = styled.li`
a {
  display: block;
  transition: opacity ${fastDurationTime} ease;
  &:hover {
    opacity: .6;
  }
}
span {
  color: #fff;
  ${text('18px', 1)}
  display: block;
  margin: 21px 0;
  padding: 0 20px;
}
&:not(:first-of-type) {
  span {
    ${dot('y', 1, 3, '#fff')}
  }
}
`
const Content = styled.div`
`
const Inner = styled.div`
  overflow: hidden;
`
const Section = styled.section`
position: relative;
padding-top: 120px;
padding-bottom: 120px;

${mq.sp} {
  padding-top: 60px;
  padding-bottom: 60px;
}
&#section-effects {
  background-color: #f5f2e9;
}
&#section-lineup, &#section-tvcm {
  background-color: #dcc477;
}
&#section-tvcm {
  margin-bottom: 58px;
  padding-bottom: 180px;
  ${mq.sp} {
    margin-bottom: 50px;
    padding-bottom: 90px;
  }
}
`
const Heading = styled.h2`
color: ${colorMain};
font-weight: bold;
${text('42px', (64/42))}
text-align: center;
padding-bottom: 80px;
${mq.sp} {
  ${text('36px', (98/72))}
  padding-bottom: 60px;
}
`

const MiddleHeadingMultiCol = styled.div`
  display: table;
  margin: auto;
`

const MiddleHeading = styled.h3`
display: inline-block;
color: ${colorAccent};
font-weight: bold;
${text('20px', (38/26))}
border-bottom: solid 2px ${colorAccent};
${mq.sp} {
  ${text('22px', (76/44))}
}
`
const SmallHeading = styled.h4`
color: ${colorMain};
font-weight: bold;
${text('18px', (30/18))}
${props => props.bordered && `
  line-height: 1;
  padding-left: 12px;
  border-left: solid 5px ${colorAccent};
`}
`
const Num = styled.span`
display: inline-block;
span {
  font-family: ${fontEn};
}
#lineup & {
  width: 61px;
  transform: translateY(25%);
}
#effects h2 & {
  color: ${colorAccent};
  span {
    font-size: 50px;
  }
}
#effects h4 & {
  margin-right: 16px;
}
#lineup & {
  margin: 0 21px;
}
`
const About = styled.div`
`
const AboutContent = styled.div`
${mq.pc} {
  display: flex;
  justify-content: space-between;
}
`
const AboutImg = styled.div`
text-align: center;
${mq.pc} {
  width: calc((100% - 42px) / 2 - 0.1px);
}
${mq.sp} {
  margin-bottom: 50px;
  padding: 0 10px;
}
`
const AboutText = styled.div`
${mq.pc} {
  width: calc((100% - 42px) / 2 - 0.1px);
}
h3 {
  margin-bottom: 40px;
}
h4 {
  margin-bottom: 12px;
  ${mq.sp} {
    margin-bottom: 22px;
  }
}
p {
  margin-bottom: 24px;
}
`
const Effects = styled.div`
`
const EffectsContent = styled.div`
`
const EffectsList = styled.ol`
${mq.pc} {
  display: flex;
  justify-content: space-between;
}
`
const EffectsItem = styled.li`
display: flex;
flex-direction: column;
justify-content: space-between;
padding: 0 43px;
${mq.pc} {
  width: calc(100% / 3 - 0.1px);
}
${mq.sp} {
  padding: 0;
}
&:not(:last-of-type) {
  ${mq.pc} {
    border-right: solid 1px ${grayBorder};
  }
  ${mq.sp} {
    position: relative;
    margin-bottom: 40px;
    padding-bottom: 40px;
    &::before {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: ${grayBorder};
    }
  }
}
h4 {
  line-height: 1;
  margin-bottom: 20px;
  position: relative;
  & > span {
    display: inline-block;
    padding-right: 16px;
    ${dot('y', 1, 2, grayBorder)}
    background-position: right;
    color: ${colorAccent};
    font-size: 22px;
    font-weight: normal;
    line-height: 1;
  }
}
small {
  margin-top: 8px;
}
`
const EffectsImg = styled.div`
position: relative;
margin-top: 25px;
${mq.sp} {
  padding: 0 72px;
}
img {
  width: 100%;
}
&::before {
  content: "※イメージ";
  display: block;
  position: absolute;
  left: calc(50% + 45px);
  bottom: 7px;
  font-size: 10px;
  color: #a0a0a0;
  white-space: nowrap;
  ${mq.sp} {
    right: 72px;
  }
}
`
const Lineup = styled.div`
  ${mq.sp} {
    padding: 0 20px;
  }
`
const LineupContent = styled.div`
  max-width: 1132px;
  margin-right: auto;
  margin-left: auto;
  padding: 80px 0;
  overflow: hidden;
  background-color: #fff;
  ${mq.sp} {
    padding: 40px 0;
  }
`
const LineupList = styled.ul`
  ${mq.pc} {
    display: flex;
    justify-content: center;
    width: 780px;
    margin: 0 auto;
    ${mq.pcMin} {
      width: 690px;
    }
    h4 {
      min-height: calc(1.7 * 3.5em);
    }
    & + & {
      margin-top: 50px;
    }
    > *:nth-child(n + 2) {
      margin-left: 70px;

      ${mq.pcMin} {
        margin-left: 30px;
      }
    }
  }
  ${mq.sp} {
    &:not(:last-of-type) {
      position: relative;
      margin-bottom: 40px;
      padding-bottom: 40px;

      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 1px;
        background-color: ${grayBorder};
      }
    }
  }
`;
const LineupItemWrap = styled.li`
  ${mq.pc} {
    width: calc(100% / 3 * 2 - 0.1px);
  }
  > div > h3 {
    display: inline;
    padding: 0 0 5px;
    border-bottom: 0;
    background: linear-gradient(transparent 94%, ${colorMainSub} 0%);
    color: ${colorMainSub};
    ${mq.ie} {
      padding: 0;
      background: none;
      text-decoration: underline;
    }
  }
  ${mq.sp} {
    &:not(:last-of-type) {
      position: relative;
      margin-bottom: 40px;
      padding-bottom: 40px;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 1px;
        background-color: ${grayBorder};
      }
    }
  }
`;

const LineupItemInnerList = styled.ul`
  ${mq.pc} {
    display: flex;
    > li {
      width: calc((780px - 140px) / 3);
      flex-shrink: 0;
      ${mq.pcMin} {
        width: calc((690px - 60px) / 3);
      }
    }
  }
  ${mq.sp} {
    h3.spOnly {
      display: inline !important;
    }
  }
`;

const LineupItem = styled.li`
  ${mq.pc} {
    display: flex;
    flex-direction: column;
    width: calc((780px - 140px) / 3);
    ${mq.pcMin} {
      width: calc((690px - 60px) / 3);
    }
    flex-shrink: 0;
    * + & {
      margin-left: 70px;

      ${mq.pcMin} {
        margin-left: 30px;
      }
    }
  }
  ${mq.sp} {
    &:not(:last-of-type) {
      position: relative;
      margin-bottom: 40px;
      padding-bottom: 40px;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 1px;
        background-color: ${grayBorder};
      }
    }
  }
  h4 {
    letter-spacing: -0.025em;
    padding-bottom: 18px;
    span {
      display: block;
      ${text('14px', 32 / 14)}
      padding-top: 8px;
    }
  }
`;
const LineupItemInner = styled.div`
  font-feature-settings: "palt";
  ${mq.sp} {
    padding: 0 25px;
  }
  > h3 {
    display: inline;
    padding: 0 0 5px;
    border-bottom: 0;
    background: linear-gradient(transparent 94%, ${colorMainSub} 0%);
    color: ${colorMainSub};
    ${mq.ie} {
      padding: 0;
      background: none;
      text-decoration: underline;
    }
  }
`
const LineupImg = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  ${mq.sp} {
    padding: 0 35px;
  }
`
const LineupLabel = styled.div`
margin-bottom: 28px;
> span > span {
  color: ${colorMainSub};
  background-color: transparent;
  padding: 3px 4px;
  border: solid 1px ${colorMainSub};
}
`
const LineupStimulationLevel = styled.div`
position: relative;
margin-bottom: 36px;

> div {
  display: flex;
  > span {
    display: block;
    color: ${colorMain};
    ${text('14px', 1)}
    padding-right: 12px;
    white-space: nowrap;
    ${mq.sp} {
      padding-right: 10px;
      white-space: nowrap;
    }
  }
  > div {
    position: relative;
    color: ${colorAccent};
    width: 100%;
    background-color: #f1e6c6;
    &::before, &::after {
      position: absolute;
      bottom: -17px;
      color: #8a763e;
      font-size: 12px;
      font-weight: bold;
      line-height: 1;
    }
    &::before {
      content: "やさしい";
      left: 0;
    }
    &::after {
      content: "強い";
      right: 0;
    }
    > span {
      height: 12px;
    }
  }
}
`
const LineupDetail = styled.div`
margin-bottom: 30px;
height: 34px;
dl {
  display: flex;
  letter-spacing: -0.02em;
}
dt,
dd {
  color: ${colorMain};
  ${text('14px', 1.5)}
}
dt {
  padding-right: 1em;
  white-space: nowrap;
}
`
const LineupButtons = styled.div`
  margin-bottom: 12px;
  ${mq.pc} {
    margin-top: auto;
  }
  ${mq.sp} {
    margin-bottom: 21px;
  }
`
const LineupButton = styled.a`
  background-repeat: no-repeat;
  background-image:
    url(${btnLineup}),
    url(${btnLineupBase});
  background-position:
  top left,
  bottom right;
  background-size: ${289 / 292 * 100}% 43px;
  display: block;
  height: 47px;
  margin-bottom: 9px;
  position: relative;
  transition: background-image ${fastDurationTime} ease;
  ${mq.sp} {
    margin-bottom: 15px;
    background-image:
    url(${btnLineupSp}),
    url(${btnLineupBaseSp});
  }
  ${mq.pc} {
    &:hover {
      background-image:
      url(${btnLineupHover}),
      url(${btnLineupBaseHover});
    }
  }
`
const LineupButtonImg = styled.span`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: opacity ${fastDurationTime} ease;
  ${props => props.store === 'amazon' ? 'width: 70px; height: 33px;' : '' }
  ${props => props.store === 'rakuten' ? 'width: 84px; height: 19px;' : '' }
  ${props => props.store === 'lohaco' ? 'width: 81px; height: 23px;' : '' }

  ${props => props.hover ? `
    opacity: 0;
    ${mq.pc} {
      a:hover & {
        opacity: 1;
      }
    }
  ` : `
    opacity: 1;
    ${mq.pc} {
      a:hover & {
        opacity: 0;
      }
    }
  `}
`
const LineupLink = styled.div`
  text-align: center;
  span {
    color: ${colorMain};
    letter-spacing: 0.1em;
  }
  path {
    stroke: ${colorMain};
  }
`
const Howto = styled.div`
`
const HowtoRow = styled.div`
  margin-bottom: 60px;
  ${mq.pc} {
    display: flex;
  }
  > div {
    ${mq.pc} {
      width: 50%;
    }
    & + div {
      position: relative;
      ${mq.pc} {
        margin-left: 42px;
      }
      ${mq.sp} {
        margin-top: 65px;
      }
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: -29px;
        margin: auto;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 11px 0 11px 20px;
        border-color: transparent transparent transparent #bfa356;
        ${mq.sp} {
          top: -40px;
          bottom: auto;
          left: 0;
          right: 0;
          border-width: 20px 11px 0 11px;
          border-color: #bfa356 transparent transparent transparent;
        }
      }
    }
  }
`
const HowtoPoint = styled.div`
  ${mq.pc} {
    display: flex;
    justify-content: space-between;
  }
`
const HowtoPointImg = styled.div`
  ${mq.pc} {
    width: ${626 / 960 * 100}%
  }
  ${mq.sp} {
    margin-bottom: 30px;
  }
`
const HowtoPointTxt = styled.div`
  ${mq.pc} {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: ${292 / 960 * 100}%
  }
  > h5 {
    position: relative;
    margin-bottom: 21px;
    padding-left: 6px;
    color: #fff;
    font-family: ${fontEn};
    font-size: 20px;
    font-weight: normal;
    line-height: 1;
    letter-spacing: 0.1em;
    span {
      position: relative;
      z-index: 10;
    }
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: -1px;
      left: 0;
      width: 115px;
      border-bottom: 23px solid #bfa356;
      border-right: 23px solid transparent;
      height: 0;
    }
  }
  > p {
    color: ${colorMain};
    font-weight: bold;
  }
`
const MovieModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  transition: opacity ${baseDurationTime} ease;
  &.is-open {
    opacity: 1;
    pointer-events: all;
  }
`
const MovieModalClose = styled.button`
  position: absolute;
  top: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  &::before, &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 50px;
    height: 1px;
    margin: auto;
    background-color: #fff;
  }
  &::before {
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(-45deg);
  }
`
const MovieModalInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 960px;
  ${mq.sp} {
    width: calc(100% - 20px);
  }
  &::before {
    content: "";
    display: block;
    padding-top: ${360 / 640 * 100}%;
  }
  & > div {
    position: absolute;
    top: 0;
    left: 0;
  }
`
const BgPattern = styled.div`
  position: absolute;
  ${props => props.top && `top: ${props.top}px`};
  ${props => props.bottom && `bottom: ${props.bottom}px`};
  ${props => props.left && `left: ${props.left / 1440 * 100}%`};
  ${props => props.right && `right: ${props.right / 1440 * 100}%`};
  width: ${props => props.originSize / 1440 * 100}%;
  ${props => props.contentOn && 'z-index: 10;'}
`

export default class Premiumcare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isSp: false, isModalOpen: false};
    this.resizeHandler = this.resizeHandler.bind(this);
  }
  componentDidMount() {
    this.setState({isSp: breakP >= window.innerWidth});
    window.addEventListener('resize', this.resizeHandler);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }
  resizeHandler() {
    this.setState({isSp: breakP >= window.innerWidth});
  }
  modalHandler(isOpen) {
    this.setState({isModalOpen: isOpen});
  }
  render() {

    return(
      <Container>
        <Helmet
          title="モンダミン プレミアムケア むし歯、歯肉炎など様々なお口のトラブル予防に | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: '7つの効果がオールインワン！モンダミン プレミアムケアのスペシャルページ。むし歯予防、歯肉炎予防、出血予防、口臭予防など、プレミアムケアの7つの効果のしくみや、3つの長続きについてご紹介します。'},
              { name: 'keywords', content: '口臭,歯肉炎,口臭ケア,むし歯予防,ノンアルコール,マウスウォッシュ,洗口液,モンダミン,mondahmin,オーラルケア' }
          ]}
        >
          <body data-small-header="true" />
        </Helmet>
        <Hero>
          <h1>
            {!this.state.isSp && <HeroProduct><InViewWrapper><Image filename={'premiumcare/img-main-products.png'} alt="モンダミン プレミアムケア 医薬部外品 洗口液"></Image></InViewWrapper></HeroProduct>}
            {!this.state.isSp ? <Image filename={'premiumcare/img-main.jpg'} alt="口内トラブルまるごとケア ALL in 1"></Image> : <Image filename={'premiumcare/sp/img-main.jpg'} alt="口内トラブルまるごとケア ALL in 1"></Image>}
          </h1>
        </Hero>
        <Content>
          <Inner>
            <Section>
              {!this.state.isSp && <BgPattern top={91} left={-298} originSize={566}><Image filename={'premiumcare/bg-pattern-01.png'}></Image></BgPattern>}
              <InViewWrapper isFadeIn>
                <ContentWidth>
                  <About id="about">
                    <AboutContent>
                      <AboutImg>
                        {!this.state.isSp ? <Image filename={'premiumcare/img-about-01.png'} alt=""></Image> : <Image filename={'premiumcare/sp/img-about-01.png'} alt=""></Image>}
                      </AboutImg>
                      <AboutText>
                        <MiddleHeading>プレミアムケアの効果のしくみ</MiddleHeading>
                        <SmallHeading bordered>高い洗浄力</SmallHeading>
                        <Text>お口のトラブルの原因となる食べカスやミクロのよごれ、ネバネバをしっかり洗浄します。</Text>
                        <SmallHeading bordered>CPC<sup>＊1</sup>による殺菌</SmallHeading>
                        <Text>むし歯・歯肉炎・口臭の原因菌を殺菌するとともに、お口全体をくまなくコートし、細菌のかたまりである歯垢の付着を防ぎます。</Text>
                        <SmallHeading bordered>GK<sub>2</sub><sup>＊2</sup>による抗炎症</SmallHeading>
                        <Text>歯肉炎を予防し、引き締まった健康的な歯ぐきを保ちます。</Text>
                        <SmallHeading bordered>TXA<sup>＊3</sup>による出血予防</SmallHeading>
                        <Text>歯ぐきからの出血を予防します。</Text>
                        <SmallHeading bordered>セラックによる歯のコーティング</SmallHeading>
                        <Text>CPC<sup>＊1</sup>とともに歯の表面をコートして、むし歯菌や酸から歯を守ります。</Text>
                        <Caption>＊１ CPC：セチルピリジニウム塩化物水和物</Caption>
                        <Caption>＊２ GK<sub>2</sub>：グリチルリチン酸ジカリウム</Caption>
                        <Caption>＊３ TXA：トラネキサム酸</Caption>
                      </AboutText>
                    </AboutContent>
                  </About>
                </ContentWidth>
              </InViewWrapper>
            </Section>
            <Section id="section-effects">
              {!this.state.isSp && <BgPattern top={-240} right={-240} originSize={491}><Image filename={'premiumcare/bg-pattern-02.png'}></Image></BgPattern>}
              <InViewWrapper isFadeIn>
                <ContentWidth>
                  <Effects id="effects">
                    <Heading><Num><span>3</span>つ</Num>の長続き</Heading>
                    <EffectsContent>
                      <EffectsList>
                        <EffectsItem>
                          <div>
                            <SmallHeading>
                              <Num><span>01</span></Num>
                              殺菌コート
                            </SmallHeading>
                            <Text>口臭・ネバツキなど、お口のトラブルの原因となる菌の増殖を長時間抑制します。</Text>
                          </div>
                          <EffectsImg><img src={effectIcon01} alt="殺菌コート" /></EffectsImg>
                        </EffectsItem>
                        <EffectsItem>
                          <div>
                            <SmallHeading>
                              <Num><span>02</span></Num>
                              酸から歯を守る
                            </SmallHeading>
                            <Text>歯を酸から長時間守ります。</Text>
                            </div>
                          <EffectsImg><img src={effectIcon02} alt="酸から歯を守る" /></EffectsImg>
                        </EffectsItem>
                        <EffectsItem>
                          <div>
                            <SmallHeading>
                              <Num><span>03</span></Num>
                              清涼感
                            </SmallHeading>
                            <Text>ひんやり心地よい清涼感がさらに長続き<sup>＊</sup>します。</Text>
                          </div>
                          <Caption>＊従来品比</Caption>
                          <EffectsImg><img src={effectIcon03} alt="清涼感" /></EffectsImg>
                        </EffectsItem>
                      </EffectsList>
                    </EffectsContent>
                  </Effects>
                </ContentWidth>
              </InViewWrapper>
            </Section>
            <Section id="section-lineup">
              {!this.state.isSp && <BgPattern top={-138} left={-252} originSize={584}><Image filename={'premiumcare/bg-pattern-03.png'}></Image></BgPattern>}
              <InViewWrapper isFadeIn>
                <Lineup id="lineup">
                  <Heading>選べるラインナップ</Heading>
                  <LineupContent>
                    <LineupList>
                      <LineupItem>
                        <LineupItemInner>
                          <MiddleHeading>すっきりさわやかな<Br />使い心地</MiddleHeading>
                          <LineupImg><Image filename={'premiumcare/img-lineup-01.png'} alt="モンダミン プレミアムケア"></Image></LineupImg>
                          <SmallHeading>モンダミン <Br />プレミアムケア</SmallHeading>
                          <LineupLabel>
                          <LabelGroup labels={['医薬部外品', '洗口液']}></LabelGroup>
                          </LineupLabel>
                          <LineupStimulationLevel>
                            <StimulationLevel isLp level={'3.5'}></StimulationLevel>
                          </LineupStimulationLevel>
                          <LineupDetail>
                            <dl>
                              <dt>サイズ</dt>
                              <dd>100mL / 380mL / 1080mL / 1.7L</dd>
                            </dl>
                          </LineupDetail>
                        </LineupItemInner>
                        <LineupButtons>
                          <LineupButton href="https://www.amazon.co.jp/dp/B074G2Q64Z/" target="_blank">
                            <LineupButtonImg store={'amazon'}><Image filename={'logo-amazon.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'amazon'}><Image filename={'logo-amazon-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                          <LineupButton href="https://item.rakuten.co.jp/rakuten24/e518249h/" target="_blank">
                            <LineupButtonImg store={'rakuten'}><Image filename={'logo-rakuten.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'rakuten'}><Image filename={'logo-rakuten-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                          <LineupButton href="https://lohaco.yahoo.co.jp/store/h-lohaco/item/1866065/" target="_blank">
                            <LineupButtonImg store={'lohaco'}><Image filename={'logo-lohaco.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'lohaco'}><Image filename={'logo-lohaco-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                        </LineupButtons>
                        <LineupLink>
                          <BtnBlank href={'https://www.earth.jp/products/mondahmin-premiumcare-1080/index.html'}>製品詳細を見る</BtnBlank>
                        </LineupLink>
                      </LineupItem>
                      <LineupItemWrap>
                        <MiddleHeadingMultiCol className="pcOnly">
                          <MiddleHeading>ノンアルコールで<Br />やさしい使い心地</MiddleHeading>
                        </MiddleHeadingMultiCol>
                        <LineupItemInnerList>
                          <LineupItem>
                            <LineupItemInner>
                              <MiddleHeading className="spOnly">ノンアルコールで<Br />やさしい使い心地</MiddleHeading>
                              <LineupImg><Image filename={'premiumcare/img-lineup-02.png'} alt="モンダミン プレミアムケア センシティブ"></Image></LineupImg>
                              <SmallHeading>モンダミン プレミアムケア <Br />センシティブ</SmallHeading>
                              <LineupLabel>
                              <LabelGroup labels={['医薬部外品', '洗口液']}></LabelGroup>
                              </LineupLabel>
                              <LineupStimulationLevel>
                                <StimulationLevel isLp level={'2.5'}></StimulationLevel>
                              </LineupStimulationLevel>
                              <LineupDetail>
                                <dl>
                                  <dt>サイズ</dt>
                                  <dd>380mL / 1080mL / 1.7L</dd>
                                </dl>
                              </LineupDetail>
                            </LineupItemInner>
                            <LineupButtons>
                              <LineupButton href="https://www.amazon.co.jp/dp/B074G317RR/" target="_blank">
                                <LineupButtonImg store={'amazon'}><Image filename={'logo-amazon.png'} alt=""></Image></LineupButtonImg>
                                {!this.state.isSp && <LineupButtonImg hover store={'amazon'}><Image filename={'logo-amazon-hover.png'} alt=""></Image></LineupButtonImg>}
                              </LineupButton>
                              <LineupButton href="https://item.rakuten.co.jp/rakuten24/e518252h/" target="_blank">
                                <LineupButtonImg store={'rakuten'}><Image filename={'logo-rakuten.png'} alt=""></Image></LineupButtonImg>
                                {!this.state.isSp && <LineupButtonImg hover store={'rakuten'}><Image filename={'logo-rakuten-hover.png'} alt=""></Image></LineupButtonImg>}
                              </LineupButton>
                              <LineupButton href="https://lohaco.yahoo.co.jp/store/h-lohaco/item/4763080/" target="_blank">
                                <LineupButtonImg store={'lohaco'}><Image filename={'logo-lohaco.png'} alt=""></Image></LineupButtonImg>
                                {!this.state.isSp && <LineupButtonImg hover store={'lohaco'}><Image filename={'logo-lohaco-hover.png'} alt=""></Image></LineupButtonImg>}
                              </LineupButton>
                            </LineupButtons>
                            <LineupLink>
                              <BtnBlank href={'https://www.earth.jp/products/mondahmin-premiumcare-sensitive-1080/index.html'}>製品詳細を見る</BtnBlank>
                            </LineupLink>
                          </LineupItem>
                          <LineupItem>
                            <LineupItemInner>
                              <MiddleHeading className="spOnly">ノンアルコールで<Br />やさしい使い心地</MiddleHeading>
                              <LineupImg><Image filename={'premiumcare/img-lineup-04.png'} alt="モンダミン プレミアムケア ストロングミントモンダミン プレミアムケア センシティブ プレミアムシトラスミント"></Image></LineupImg>
                              <SmallHeading>モンダミン プレミアムケア <Br />センシティブ <Br />プレミアムシトラスミント</SmallHeading>
                              <LineupLabel>
                              <LabelGroup labels={['医薬部外品', '洗口液']}></LabelGroup>
                              </LineupLabel>
                              <LineupStimulationLevel>
                                <StimulationLevel isLp level={'2.5'}></StimulationLevel>
                              </LineupStimulationLevel>
                              <LineupDetail>
                                <dl>
                                  <dt>サイズ</dt>
                                  <dd>1080mL</dd>
                                </dl>
                              </LineupDetail>
                            </LineupItemInner>
                            <LineupButtons>
                              <LineupButton href="https://www.amazon.co.jp/dp/B08X48R12Y/" target="_blank">
                                <LineupButtonImg store={'amazon'}><Image filename={'logo-amazon.png'} alt=""></Image></LineupButtonImg>
                                {!this.state.isSp && <LineupButtonImg hover store={'amazon'}><Image filename={'logo-amazon-hover.png'} alt=""></Image></LineupButtonImg>}
                              </LineupButton>
                              <LineupButton href="https://item.rakuten.co.jp/rakuten24/4901080587015/" target="_blank">
                                <LineupButtonImg store={'rakuten'}><Image filename={'logo-rakuten.png'} alt=""></Image></LineupButtonImg>
                                {!this.state.isSp && <LineupButtonImg hover store={'rakuten'}><Image filename={'logo-rakuten-hover.png'} alt=""></Image></LineupButtonImg>}
                              </LineupButton>
                              <LineupButton href="https://lohaco.yahoo.co.jp/store/h-lohaco/item/AA02572/" target="_blank">
                                <LineupButtonImg store={'lohaco'}><Image filename={'logo-lohaco.png'} alt=""></Image></LineupButtonImg>
                                {!this.state.isSp && <LineupButtonImg hover store={'lohaco'}><Image filename={'logo-lohaco-hover.png'} alt=""></Image></LineupButtonImg>}
                              </LineupButton>
                            </LineupButtons>
                            <LineupLink>
                              <BtnBlank href={'https://www.earth.jp/products/mondahmin-premiumcare-sensitive-1080-citrus-mint/index.html'}>製品詳細を見る</BtnBlank>
                            </LineupLink>
                          </LineupItem>
                        </LineupItemInnerList>
                      </LineupItemWrap>
                    </LineupList>
                    <LineupList>
                      <LineupItem>
                        <LineupItemInner>
                          <MiddleHeading>ハードで爽快な<Br />使い心地</MiddleHeading>
                          <LineupImg><Image filename={'premiumcare/img-lineup-03.png'} alt="モンダミン プレミアムケア ストロングミント"></Image></LineupImg>
                          <SmallHeading>モンダミン プレミアムケア <Br />ストロングミント</SmallHeading>
                          <LineupLabel>
                          <LabelGroup labels={['医薬部外品', '洗口液']}></LabelGroup>
                          </LineupLabel>
                          <LineupStimulationLevel>
                            <StimulationLevel isLp level={'6'}></StimulationLevel>
                          </LineupStimulationLevel>
                          <LineupDetail>
                            <dl>
                              <dt>サイズ</dt>
                              <dd>1080mL</dd>
                            </dl>
                          </LineupDetail>
                        </LineupItemInner>
                        <LineupButtons>
                          <LineupButton href="https://www.amazon.co.jp/dp/B084RVVY2V/" target="_blank">
                            <LineupButtonImg store={'amazon'}><Image filename={'logo-amazon.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'amazon'}><Image filename={'logo-amazon-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                          <LineupButton href="https://item.rakuten.co.jp/rakuten24/4901080508713/" target="_blank">
                            <LineupButtonImg store={'rakuten'}><Image filename={'logo-rakuten.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'rakuten'}><Image filename={'logo-rakuten-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                          <LineupButton href="https://lohaco.yahoo.co.jp/store/h-lohaco/item/X371904/" target="_blank">
                            <LineupButtonImg store={'lohaco'}><Image filename={'logo-lohaco.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'lohaco'}><Image filename={'logo-lohaco-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                        </LineupButtons>
                        <LineupLink>
                          <BtnBlank href={'https://www.earth.jp/products/mondahmin-premiumcare-strongmint-1080/index.html'}>製品詳細を見る</BtnBlank>
                        </LineupLink>
                      </LineupItem>
                      <LineupItem>
                        <LineupItemInner>
                          <MiddleHeading>かざすだけで<Br />簡単＆衛生的！</MiddleHeading>
                          <LineupImg><Image filename={'premiumcare/img-lineup-05.png'} alt="自動で出てくるモンダミン プレミアムケアセット"></Image></LineupImg>
                          <SmallHeading>自動で出てくるモンダミン<Br />プレミアムケアセット</SmallHeading>
                          <LineupLabel>
                          <LabelGroup labels={['医薬部外品', '洗口液']}></LabelGroup>
                          </LineupLabel>
                          <LineupStimulationLevel>
                            <StimulationLevel isLp level={'3.5'}></StimulationLevel>
                          </LineupStimulationLevel>
                          <LineupDetail>
                            <dl>
                              <dt>サイズ</dt>
                              <dd>860mL</dd>
                            </dl>
                          </LineupDetail>
                        </LineupItemInner>
                        <LineupButtons>
                          <LineupButton href="https://www.amazon.co.jp/dp/B0CKBCGS8X/https://www.amazon.co.jp/dp/B0CKBCGS8X/" target="_blank">
                            <LineupButtonImg store={'amazon'}><Image filename={'logo-amazon.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'amazon'}><Image filename={'logo-amazon-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                          <LineupButton href="https://item.rakuten.co.jp/rakuten24/4901080153210/" target="_blank">
                            <LineupButtonImg store={'rakuten'}><Image filename={'logo-rakuten.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'rakuten'}><Image filename={'logo-rakuten-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                          <LineupButton href="https://lohaco.yahoo.co.jp/store/h-lohaco/item/XP44069/?sc_e=zb_pmkr_aas_bea_beap_dps_XP44069" target="_blank">
                            <LineupButtonImg store={'lohaco'}><Image filename={'logo-lohaco.png'} alt=""></Image></LineupButtonImg>
                            {!this.state.isSp && <LineupButtonImg hover store={'lohaco'}><Image filename={'logo-lohaco-hover.png'} alt=""></Image></LineupButtonImg>}
                          </LineupButton>
                        </LineupButtons>
                        <LineupLink>
                          <BtnBlank href={'https://www.earth.jp/products/mondahmin-premium-dispenser-860/index.html'}>製品詳細を見る</BtnBlank>
                        </LineupLink>
                      </LineupItem>
                    </LineupList>
                  </LineupContent>
                </Lineup>
              </InViewWrapper>
            </Section>
            <Section>
              {!this.state.isSp && <BgPattern top={-311} right={-357} originSize={618}><Image filename={'premiumcare/bg-pattern-04.png'}></Image></BgPattern>}
              {!this.state.isSp && <BgPattern top={119} left={-12} originSize={307}><Image filename={'premiumcare/bg-pattern-05.png'}></Image></BgPattern>}
              {!this.state.isSp && <BgPattern bottom={188} right={425} originSize={158}><Image filename={'premiumcare/bg-pattern-08.png'}></Image></BgPattern>}
              <InViewWrapper isFadeIn>
                <ContentWidth>
                  <Howto id="howto">
                    <Heading>プレミアムケアの<Br onlySp></Br>使い方</Heading>
                    <HowtoRow>
                      <div>{!this.state.isSp ? <Image filename={'premiumcare/img-howto-01.jpg'}></Image> : <Image filename={'premiumcare/sp/img-howto-01.jpg'}></Image>}</div>
                      <div>{!this.state.isSp ? <Image filename={'premiumcare/img-howto-02.jpg'}></Image> : <Image filename={'premiumcare/sp/img-howto-02.jpg'}></Image>}</div>
                    </HowtoRow>
                    <HowtoPoint>
                      <HowtoPointImg>{!this.state.isSp ? <Image filename={'premiumcare/img-howto-03.jpg'}></Image> : <Image filename={'premiumcare/sp/img-howto-03.jpg'}></Image>}</HowtoPointImg>
                      <HowtoPointTxt>
                        <h5><span>POINT</span></h5>
                        <Text>歯みがき後はもちろん、外出先や忙しくて歯みがきができない時や、お口の不快感が気になった時などにもおすすめ！</Text>
                      </HowtoPointTxt>
                    </HowtoPoint>
                  </Howto>
                </ContentWidth>
              </InViewWrapper>
            </Section>
          </Inner>
        </Content>
        <MovieModal className={this.state.isModalOpen ? 'is-open' : null}>
          <MovieModalClose onClick={() => this.modalHandler(false)}></MovieModalClose>
          <MovieModalInner>
            <ReactPlayer url={'https://youtu.be/2E21OpJKNUE'} playing={this.state.isModalOpen} width={"100%"} height={"100%"}></ReactPlayer>
          </MovieModalInner>
        </MovieModal>
      </Container>
    );
  }
}
